// etc
import watchUIState from "modules/ui/sagas";
import watchAuthState from "modules/auth/sagas";
import watchMasterDataMangement from "modules/master-data/sagas";
import watchProductMangement from "modules/product-management/sagas"
import watchSaleorderDataMangement from "modules/sale-order/sagas"


import { fork, all } from "redux-saga/effects";

export default function* rootSagas() {
  yield all([
    fork(watchUIState),
    fork(watchAuthState),
    ...watchMasterDataMangement,
    ...watchProductMangement,
    ...watchSaleorderDataMangement
  ]);
}
